import type { ScenarioListItem } from '../lib/piClient.js';

interface Props {
  scenarios: readonly ScenarioListItem[];
  value: string | null;
  onChange(name: string): void;
  disabled?: boolean;
  /**
   * When set, the selector is disabled and this explains why (e.g. the Pi
   * health check failed). Shown as the placeholder text, a hover tooltip,
   * and a hint line — so an empty dropdown can't be misread as "still
   * loading".
   */
  disabledReason?: string | null;
}

export function ScenarioSelector({
  scenarios,
  value,
  onChange,
  disabled,
  disabledReason = null,
}: Props) {
  const selected = scenarios.find((s) => s.name === value) ?? null;
  const placeholder =
    disabledReason ??
    (scenarios.length === 0 ? '(loading scenarios…)' : 'Select a scenario');
  return (
    <div>
      <label htmlFor="scenario">Scenario</label>
      <select
        id="scenario"
        value={value ?? ''}
        disabled={disabled || disabledReason !== null || scenarios.length === 0}
        title={disabledReason ?? undefined}
        onChange={(e) => onChange(e.target.value)}
      >
        <option value="" disabled>
          {placeholder}
        </option>
        {scenarios.map((s) => (
          <option key={s.name} value={s.name}>
            {s.name} — {s.country} ch{s.channel} @ {s.txPowerDbm}dBm
            {s.ieee80211d ? ' · 802.11d' : ''}
          </option>
        ))}
      </select>
      {disabledReason && <p className="muted form-disabled-hint">{disabledReason}</p>}
      {selected && !disabledReason && (
        <p className="scenario-desc">{selected.description}</p>
      )}
    </div>
  );
}
